import { PIE, FUNNEL, PIE_GRADE, TREE_MAP, GRAPH_BUBBLE } from 'src/components/Charts/types';
import { CORRELATION_CARD, MULTIPLE_CARD, SIMPLE_CARD } from 'src/sections/GroupCards/cardTypes';

function getDefaultContextSeriesIndex(ctx) {
  return ctx.seriesIndex;
}

function getCustomContextDataIndex(ctx) {
  return ctx.dataIndex;
}

// No treemap o "índice" é a posição da pergunta correlacionada (nível 3 do treePath) dentro
// de `option.legend.data`. Essa lista é canônica e está alinhada com `option.color`
// (montada pelo `toTreeMapEchartOption`), de modo que o pipeline padrão de cor por índice
// continua válido para o treemap.
function getTreeMapPerguntaIndex(ctx, options) {
  const { treePathInfo } = ctx;
  if (!Array.isArray(treePathInfo)) return -1;
  const perguntaNode = treePathInfo[2];
  if (!perguntaNode || !options || !options.legend || !Array.isArray(options.legend.data)) {
    return -1;
  }
  return options.legend.data.indexOf(perguntaNode.name);
}

// No graph_bubble o `toEchartOption` remapeia as categorias para que as perguntas
// correlacionadas fiquem em 0..N-1 (alinhadas com `option.legend.data`) — a pergunta
// principal não recebe `category` e é pintada via `itemStyle.color` fixo. Portanto:
//   - node sem `category` (principal): índice -1 (não abre color picker)
//   - node com `category`: índice canônico = `category`
function getGraphBubblePerguntaIndex(ctx) {
  const category = ctx && ctx.data && typeof ctx.data.category === 'number' ? ctx.data.category : -1;
  if (category < 0) return -1;
  return category;
}

const contextIndexByChartType = {
  [`${SIMPLE_CARD}_${PIE}`]: getCustomContextDataIndex,
  [`${MULTIPLE_CARD}_${PIE}`]: getCustomContextDataIndex,
  [`${SIMPLE_CARD}_${FUNNEL}`]: getCustomContextDataIndex,
  [`${SIMPLE_CARD}_${PIE_GRADE}`]: getCustomContextDataIndex,

  [`${CORRELATION_CARD}_${TREE_MAP}`]: getTreeMapPerguntaIndex,
  // SIMPLE_BUBBLE não precisa de resolver custom: cada pergunta é uma série e o `seriesIndex`
  // do echarts já corresponde diretamente ao índice canônico em `option.legend.data`.
  [`${CORRELATION_CARD}_${GRAPH_BUBBLE}`]: getGraphBubblePerguntaIndex,

  default: getDefaultContextSeriesIndex,
};

/**
 * Estratégia aplicada para recuperar o índice de um item do gráfico selecionado
 * pelo usuário ao abrir o color picker. Esse índice é a posição dentro da configuração
 * de series do echartOption do gráfico. É default porquê é aplicada para todos os gráficos
 * que não derem match com a estratégia selecionada.
 * @param {object} ctx Objeto de contexto de um evento disparado em um gráfico
 * @param {string} identifier Tipo do gráfico atualmente manipulado
 * @param {object} options Opções atuais do echarts — algumas estratégias (ex: treemap) precisam
 *  inspecionar a configuração para resolver o índice a partir de uma chave hierárquica.
 * @returns {number} indice do item clicado em um gráfico
 */
export default function getContextIndexByChartType(ctx, identifier, options) {
  const contextIndexStrategy = contextIndexByChartType[identifier] || contextIndexByChartType.default;
  return contextIndexStrategy(ctx, options);
}
